import { useCallback } from 'react';
import analyticsService from '../services/analytics';

/**
 * Hook for using analytics in React components
 * Returns methods to track various user interactions
 */
export function useAnalytics() {
  // Removed useEffect to track feature entry on component mount

  // Return wrapped methods to use within components
  return {
    // Authentication events
    trackLogin: useCallback(() => analyticsService.trackLogin(), []),
    trackLoginFailed: useCallback(() => analyticsService.trackLoginFailed(), []),
    trackLogout: useCallback(() => analyticsService.trackLogout(), []),
    trackProfileLinked: useCallback(() => analyticsService.trackProfileLinked(), []),
    
    // Profile events
    trackSummaryEdited: useCallback(() => analyticsService.trackSummaryEdited(), []),
    trackSummaryRegenerated: useCallback(() => analyticsService.trackSummaryRegenerated(), []),
    trackInterestAdded: useCallback((interest) => analyticsService.trackInterestAdded(interest), []),
    trackInterestRemoved: useCallback((interest) => analyticsService.trackInterestRemoved(interest), []),
    trackAbstractEdited: useCallback((abstractId) => analyticsService.trackAbstractEdited(abstractId), []),
    
    // Grant discovery events
    trackGrantViewed: useCallback((grantId, grant) => analyticsService.trackGrantViewed(grantId, grant), []),
    trackGrantSearched: useCallback((query) => analyticsService.trackGrantSearched(query), []),
    trackGrantFiltered: useCallback((filters) => analyticsService.trackGrantFiltered(filters), []),
    trackGrantLinkClicked: useCallback((grantId, url, opportunityId) => analyticsService.trackGrantLinkClicked(grantId, url, opportunityId), []),
    trackPaginationUsed: useCallback((page, context) => analyticsService.trackPaginationUsed(page, context), []),
    
    // Chat events
    trackChatStarted: useCallback((threadId) => analyticsService.trackChatStarted(threadId), []),
    trackChatQuery: useCallback((query, threadId) => analyticsService.trackChatQuery(query, threadId), []),
    trackChatEnded: useCallback((threadId) => analyticsService.trackChatEnded(threadId), []),
    
    // Tab events - only keep trackTabEndedSync for duration tracking
    trackTabEndedSync: useCallback((tabViewId, tabName, duration) => 
      analyticsService.trackTabEndedSync(tabViewId, tabName, duration), []),
    
    // System events
    trackError: useCallback((errorMsg, context) => analyticsService.trackError(errorMsg, context), []),
    
    // Feedback events
    trackFeedbackSubmitted: useCallback((feedbackType) => analyticsService.trackFeedbackSubmitted(feedbackType), []),
    trackBugReported: useCallback((description) => analyticsService.trackBugReported(description), []),
  };
} 